import PageHeader from "@/components/site/PageHeader";
import { Contact, Newsletter } from "@/components/site/Forms";
import { usePageMeta } from "@/lib/usePageMeta";

export default function ContactPage() {
  usePageMeta(
    "Contact Us",
    "Get in touch with RE//FORM PLACE CHI in Chicago — call (773) 940-5265 or email info@reformplacechi.org. We'd love to connect, answer questions, and pray with you.",
  );
  return (
    <div data-testid="contact-page">
      <PageHeader
        crumb="Contact"
        eyebrow="Contact"
        title="Connect"
        accent="With Us"
        intro="Questions, pastoral care, partnerships, or press — reach out and a member of our team will respond soon."
        image="/outreach/shanita-team.webp"
        imagePosition="center 30%"
      />
      <Contact />
      <Newsletter />
    </div>
  );
}
